export function createRoute(pathName, params = {}) {
  const path = pathName.replace(/(\/)?:(\w+)\??/g, (_match, slash, param) =>
    params[param] ? `${slash}${params[param]}` : ''
  );
  return path;
}

export function getQueryParamByName(queryParams, name) {
  const results = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)').exec(
    queryParams
  );

  if (!results || !results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
